import React, { useEffect, useState } from 'react';

function HistoryPage() {
    const [history, setHistory] = useState([]);
    const [expandedItems, setExpandedItems] = useState({}); // Track expanded state for each item


    useEffect(() => {
        const savedHistory = JSON.parse(localStorage.getItem('imageAnalysisHistory')) || [];
        setHistory(savedHistory);
    }, []);

    const toggleExpand = (index) => {
        setExpandedItems((prev) => ({
            ...prev,
            [index]: !prev[index], // Toggle the expanded state for the given index
        }));
    };

    const deleteHistoryItem = (index) => {
        const updatedHistory = history.filter((_, i) => i !== index); // Remove the selected item
        setHistory(updatedHistory); // Update the state
        localStorage.setItem('imageAnalysisHistory', JSON.stringify(updatedHistory)); // Persist changes
    };

    return (
        <div className="history-page">
        <h2>History</h2>
        <p>This is the History page. Here you can view your past uploads and analysis results.</p>
        {history.length === 0 ? (
        <p>No history available</p>
      ) : (
        <div className="history-container">
                    {history.map((item, index) => {
                        const isExpanded = expandedItems[index];
                        const analysisLines = item.analysis.split(/<br>|\\n|[\r\n]+/); // Split by line breaks
                        const displayedAnalysis = isExpanded
                            ? item.analysis // Show full text if expanded
                            : analysisLines.slice(0, 3).join('<br>'); // Show only the first 6 lines

                        return (
                            <div key={index} className="history-item">
                                <img src={item.image} alt={`Analyzed ${index}`} className="history-image" />
                                <div className="history-text" dangerouslySetInnerHTML={{ __html: displayedAnalysis }} />
                                {analysisLines.length > 3 && (
                                    <button
                                        className="toggle-button"
                                        onClick={() => toggleExpand(index)}
                                    >
                                        {isExpanded ? 'Show Less' : 'Show More'}
                                    </button>
                                )}
                                <p className="timestamp">{new Date(item.timestamp).toLocaleString()}</p>
                                <button
                                    className="delete-button"
                                    onClick={() => deleteHistoryItem(index)}
                                >
                                    Delete
                                </button>
                            </div>
                        );
                    })}
                </div>
      )}
        </div>
    );
}

export default HistoryPage;
